module.exports = __webpack_public_path__ + "img/plan-b-on.4f7cdf22.png";